module.exports = "/_next/static/images/d527bdb4b6ae9f52723131328122e3ec-promo-amazon-day.jpg.webp";